import { Component, Input, OnInit } from '@angular/core';
import { NbComponentStatus } from '@nebular/theme';
import { InfoComponent } from '../info.component';

@Component({
  selector: 'hm-info-alert',
  templateUrl: './info-alert.component.html',
  styleUrls: ['./info-alert.component.scss']
})
export class InfoAlertComponent extends InfoComponent implements OnInit {
  @Input() status: NbComponentStatus = 'danger';
  @Input() outline: NbComponentStatus = null;
}
